<div class="avatar {{ styleClass }} {{ randomBgColor }}">
  <ng-content select="[indicator]"></ng-content>
  <img
    *ngIf="avatar?.url && !hasImageLoadError"
    [alt]="accessibleName"
    class="avatar-img"
    [src]="avatar?.url"
    (error)="onImageLoadError()"
  />
  <div
    *ngIf="showInitials"
    class="avatar-initial"
    [attr.aria-label]="accessibleName || null"
    [attr.role]="accessibleName ? 'img' : null"
  >
    {{ initials }}
  </div>
</div>
